import { useRef } from 'react';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Modal from '@sdk/components/ui/modal/Modal';
import Text14 from '@sdk/components/ui/typography/Text14';
import Column from '@sdk/components/ui/spacing/Column';
import ModalFooterActionButtons from '@sdk/components/ui/modal/ModalFooterActionButtons';
import ModalBodyWithHeader from '@sdk/components/ui/modal/ModalBodyWithHeader';

import AnnouncementBlueSvg from '@web/assets/svg/Icons/32/announcement-blue.svg';

type Props = {
  isVisible: boolean;
  accept: () => void;
  decline: () => void;
  transferOwnershipMode?: boolean;
  isPremium: boolean;
};

const KeepAccountModal = ({
  isVisible,
  accept,
  decline,
  transferOwnershipMode = false,
  isPremium,
}: Props) => {
  const config = useRef({ noDismiss: true }).current;

  let description;

  if (transferOwnershipMode) {
    if (isPremium) {
      description = gettext(
        'Instead of deleting your Sling account, you can pass the ownership of it to another manager by making them an Admin, and update the payment method to another card.'
      );
    } else {
      description = gettext(
        'Instead of deleting your Sling account, you can pass the ownership of it to another manager by making them an Admin.'
      );
    }
  } else {
    description = gettext(
      'Instead of permanently deleting your Sling account, you can keep it running and come back to it later when your business resumes next season.'
    );
  }

  return (
    <>
      <Modal fixed config={config} isVisible={isVisible}>
        <ModalBodyWithHeader
          width={620}
          titleThemeColor={ThemeColorType.primary}
          titleText={
            transferOwnershipMode ? gettext('Transfer ownership') : gettext('Keep account')
          }
          titleIcon={<AnnouncementBlueSvg />}
          close={decline}>
          <Column mBottom={20}>
            <Text14 themeColor={ThemeColorType.gray}>{description}</Text14>
          </Column>
          <ModalFooterActionButtons
            mTop={0}
            cancel={decline}
            submit={accept}
            isSubmitAsync={false}
            cancelText={gettext('Nevermind')}
            submitText={gettext('Keep account')}
            buttonWidth={205}
          />
        </ModalBodyWithHeader>
      </Modal>
    </>
  );
};

export default KeepAccountModal;
